export default "__VITE_ASSET__78548994__"